<template>
    <div id="divLogin">
        <div class="header-nav">
            <ul class="menu">
                <li><span>{{ pageTitle }}</span></li>
            </ul>
        </div>

        <div id="divContent" class="main-content-row">
            <form @submit.prevent="login">
                <div class="form-group">
                    <div class="input-group">
                        <label for="txtUsername" class="controlLabel">{{ $t("message.username") }}</label>
                        <input id="txtUsername" name="username" type="text" v-model="loginData.username" class="form-control" ref="loginUsername" autofocus aria-required="true" />
                    </div>
                </div>

                <div class="form-group">
                    <div class="input-group">
                        <label for="txtPassword" class="controlLabel">{{ $t("message.password") }}</label>
                        <input id="txtPassword" name="password" type="password" v-model="loginData.password" class="form-control" v-on:keydown="checkCapsLock" aria-required="true" />
                    </div>
                </div>

                <div>
                    <label style="color:crimson;" v-if="capsOn">{{ $t("message.capsLockOn") }}</label>
                </div>

                <div class="custom-margin-bottom custom-checkbox">
                    <input id="chkRemember" type="checkbox" v-model="rememberUser" name="chkRemember">
                    <label for="chkRemember">{{ $t("message.rememberUsername") }}</label>
                </div>

                <button type="submit" class="btn btn-sm btn-primary btn-block" @click.prevent="login" :disabled="submitted" aria-label="Login">{{ $t("message.submit") }}</button>
            </form>           

            <div class="login-links">
                <!-- display links -->
                <ul class="custom-page-link">
                    <router-link tag="li" v-for="link in links" 
                                            v-bind:key="link.id" 
                                            :to="`${link.page}`"><a class="page-link">{{ link.text }}</a></router-link>
                    <li v-show="repSupportInformation !== ''"><a href="#" class="page-link" @click="showModal">{{ $t("message.supportInfo") }}</a></li>                                      
                </ul>
            </div>

            <modal v-show="isModalVisible" @close="closeModal">
                <h4 class="modal-title" slot="header">Support Information</h4>
                <div slot="body">
                    <div v-for="repSupport in repSupportInformation" :key="repSupport.Id">                        
                        <div class="panel-body">
                            <h3 class="panel-title" v-text="repSupport.Title"></h3><br />
                            <div class="email" v-if="repSupport.Email !== ''">
                                <label><b>{{ $t("message.email") }}</b>&nbsp;</label><a v-bind:href="'mailto:' + repSupport.Email">{{ repSupport.Email }}</a>
                            </div>
                            <div class="phone" v-if="repSupport.Phone !== ''">
                                <label><b>{{ $t("message.phone") }}</b>&nbsp;</label><label v-text="repSupport.Phone"></label>
                            </div>
                            <div class="additionalInfo">
                                <label v-html="repSupport.AdditionalData"></label>
                            </div>
                        </div>
                    </div>
                </div>
            </modal>
        </div>        
    </div>
</template>

<script>
import axios from "axios"
import Cookies from "js-cookie"
import Modal from '@/components/common/Modal'

export default {
    name: 'Login',
    components: {
        Modal
    },
    data() {
        return {
            loginData: {
                username: "",
                password: ""
            },
            rememberUser: false,
            capsOn: false,
            submitted: false,
            pageTitle: "Account Login",
            links: [ 
                {
                    text: 'Forgot Password?',
                    messageTag: "forgotPassword",
                    page: '/forgotpassword/password'
                },
                {
                    text: 'Forgot Username?',
                    messageTag: "forgotUsername",
                    page: '/forgotpassword/username'
                },
                {
                    text: 'New Customer? Register Here',
                    messageTag: "register",
                    page: '/register'
                }
            ],
            isModalVisible: false,
            repSupportInformation: ''
        }
    },
    methods: {
        login() {
            if (this.loginData.username.length == 0) {
                this.showError("Username cannot be empty")
                return
            }
            if (this.loginData.password.length === 0) {
                this.showError("Password cannot be empty")
                return
            }

            this.submitted = true;

            if (this.rememberUser) {
                // Create or update the user cookie, valid for 365 days
                Cookies.set("payGoUserName", this.loginData.username, {expires: 365})
            } else {
                // Remove the cookie, if it exists.
                Cookies.remove("payGoUserName")
            }

            axios({
                method: "POST",
                url: this.$httpAxiosBaseUrl() + "Login/Login",
                data: {
                    loginData: this.loginData
                }
            }).then(result => {
                var response = result.data
                if (response === undefined) {
                    // We didn't get any result back (should never get here)
                    this.showError("Error has occurred.  Please try again in a few minutes.")
                } else {

                  var lockoutMesage = response.LockoutMessage;
                  var showLockout = response.ShowLockout;

                  if (showLockout && response.LoginResults != 0) {
                    this.showError(lockoutMesage);
                    this.submitted = false;
                  }
                  else {

                    switch (response.LoginResults) {
                      case 0:
                        // Put the returned data into our result set
                        this.$store.commit('setCustomerInfo', response);
                        this.$store.commit('setAuthentication', true);

                        // Check for 'RenderPagesInIframe' property, if true - update Session Timeout duration
                        this.$store.commit('setSessionTimeout', this.$store.getters.getRenderPagesInIframe ? this.$SessionTimeoutType.PortalInIframe : this.$SessionTimeoutType.Normal);

                        // If we get a redirect link back from our response, forward user to that page OR
                        // else we will forward the user to the first link in our navigation menu object
                        var redirectLink = this.$store.getters.getRedirectLinkForLogin;
                        if (redirectLink !== '') {
                          this.$store.commit('setNavigationMenuLinks', JSON.parse(response.NavigationMenuLinks));
                          this.$router.push({ path: redirectLink });
                        } else {
                          this.$storeNavigationMenuLinksAndRedirect(response.NavigationMenuLinks, true);
                        }

                        document.title = this.$store.getters.getPageTitleFromRepThemeSettings;

                        break;
                      case 1:
                      case 2:
                        // Invalid User Name = 1, Invalid Password = 2
                        this.showError("The username / password combination you entered is invalid.")
                        this.submitted = false
                        break
                      case 3:
                        this.showError(lockoutMesage);
                        this.submitted = false
                        break
                      default:
                        // Generic Error = 4, this also handles undefined login results,
                        // which would only happen with a thrown error.
                        this.showError("A login error has occurred.  Please try again in a few minutes.")
                        this.submitted = false
                        break
                    }
                  }
 
                }
            }, error => {
                console.log(error)
            })
        },
        showModal() {
            this.isModalVisible = true
        },
        closeModal() {
            this.isModalVisible = false
        },
        checkCapsLock(e) {
            if (e) {
                var s = e.key;
                if (s) {
                    if (s.toUpperCase() === s && s.toLowerCase() !== s && !e.shiftKey) {
                        this.showError("Caps Lock Is On")
                    }
                }
            }
        },
        showError(message) {
            this.$toasted.global.error(message);
            this.$announcer.set(message);
        },
        clearSessionBeforeSetup() {
            axios({
                method: "GET",
                url: this.$httpAxiosBaseUrl() + "Login/ClearSessionForLoginPage?date=" + new Date().getTime()
            }).then(result => {
                var response = result.data;                
            }, error => {
                console.log(error);
            });
        }
    },
    mounted() {
        // Clear session before we continue loading our Login page contents
        this.clearSessionBeforeSetup();
        this.$store.dispatch('resetApp');

        this.$refs.loginUsername.focus();

        // Get Support Information        
        var supportInformationFromStore = this.$store.getters.getSupportInformation
        if (supportInformationFromStore.length > 0) {
            this.repSupportInformation = supportInformationFromStore
        } else {
            axios({
                method: "GET",
                url: this.$httpAxiosBaseUrl() + "Support/GetSupportInformation"
            }).then(result => {
                var response = result.data
                // Save our response, if we don't get anything back we will hide the Support link
                // If we get data back, we will display the link and update popup data
                this.repSupportInformation = response

                if (response !== "") {                    
                    this.$store.commit('setSupportInformation', response)
                }
            }, error => {
                console.log(error)
            })
        }   

        //TO DO: Load global server variables to the store

        //Check to see if we have a cookie that was set for the user name
        var userCookie = Cookies.get("payGoUserName")

        if (userCookie !== undefined && userCookie !== "") {
            this.rememberUser = true
            this.loginData.username = userCookie
        }
        
        //Some pages like logoff or ForgotUserName will set a message to show on load.  If it occurs, we need to show it.
        var loginMessage = this.$store.getters.getLoginMessage
        if (loginMessage !== '') {
            this.showError(loginMessage)
            this.$store.commit('setLoginMessage', '')
        }
    }
}
</script>
